export default __webpack_public_path__ + "static/media/cert_JSweb.efa24bb3.png";